<template>
  <div
    class="flex flex-col flex-1 px-5 pb-5 z-40 absolute inset-0 w-full bg-white gap-4 overflow-auto"
  >
    <div class="flex">
      <Button class="text-primary-900" @click="$emit('minimise')">
        <v-icon>mdi-fullscreen-exit</v-icon> {{ $t("calls.minimise") }}
      </Button>
    </div>
    <div class="grid grid-cols-9 flex-1 gap-6 min-h-[600px] min-w-[1000px]">
      <div class="flex flex-col col-span-3 gap-4 min-h-[500px] min-w-[260px]">
        <last-tickets
          @inTicketMode="setTicketCreateMode"
          v-if="
            hasPermisson(ticketsPermission) &&
            (inCall || withACW(acwTicketing) || ticketMode)
          "
        />
      </div>
      <div class="flex flex-col col-span-4 gap-4 min-h-[500px] min-w-[320px]">
        <new-call-reasons
          @enterReason="setReasonMode"
          v-if="inCall || withACW(acwReason) || reasonMode"
        />
        <last-reasons
          @enterReason="setReasonMode"
          v-if="inCall || reasonMode"
        />
      </div>

      <div class="flex flex-col col-span-2 gap-4 min-h-[500px] min-w-[340px]">
        <caller-info
          v-if="
            (inCall || withACW(acwCRM) || crmMode) &&
            hasPermisson(callerInfoPermission)
          "
          @infoMode="setInfoCreateMode"
        />
        <div
          class="flex flex-col justify-between h-3/5 min-h-[360px] gap-1 bg-primary-900 rounded-xl px-4 py-6 overflow-hidden shadow-lg border border-gray-100"
          :class="[{ 'shake-animation': !isAnswered && isIncoming }]"
        >
          <call-actions />
        </div>
        <!-- <div
          class="flex flex-col h-1/5 justify-center items-center bg-light-grey rounded-xl p-4 shadow-lg border border-gray-100"
        >
          <img
            ref="sentiment"
            :src="require('@/assets/normal.png')"
            alt="logo"
            class="w-16 h-16"
          />
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import LastReasons from "@/pages/call/components/LastCallReasons.vue";
import LastTickets from "@/pages/call/components/LastTickets.vue";
import CallerInfo from "@/pages/call/components/CallerInfo.vue";
import NewCallReasons from "@/pages/call/components/NewCallReasons.vue";
// import LiveTranscription from "@/pages/call/components/LiveTranscription.vue";
import CallActions from "@/pages/call/components/CallActions.vue";
import { Button } from "primevue";

export default {
  name: "homePage",
  components: {
    LastReasons,
    LastTickets,
    CallerInfo,
    NewCallReasons,
    // LiveTranscription,
    CallActions,
    Button,
  },
  data() {
    return {
      numberText: "",
      userSkills: [],
      skillsNames: [],
      drToggle: false,
      reasonMode: false,
      crmMode: false,
      ticketMode: false,
      tabToggle: "0",
      statusWidth: 0,
      restingPeriod: 0,
      selectedSkills: [],
      restStatusInt: null,
      userPermission: [],
      currentCallTimeout: null,
      reasonsTimeout: null,
      // currentCall: { CallerID: "0123456789" },
      userType: 0,
      tabheader: [
        "Recent Calls history",
        "Calls Summary of the last 7 days",
        "skills statistics",
      ],
    };
  },
  methods: {
    hasPermisson(permission) {
      return this.userPermission.includes(permission);
    },
    setReasonMode(inMode) {
      if (inMode) {
        clearTimeout(this.reasonsTimeout);
        this.reasonMode = true;
      } else {
        this.reasonsTimeout = setTimeout(() => {
          this.reasonMode = false;
        }, 5000);
      }
    },
    setInfoCreateMode(status) {
      this.crmMode = status;
    },
    setTicketCreateMode(status) {
      this.ticketMode = status;
    },
    async setSkills(sentSkillinfo) {
      let payload = {
        skills: sentSkillinfo.skills,
        workPlace: sentSkillinfo.workPlace,
        phone: sentSkillinfo.phone,
      };
      this.ShowProgressBar({ show: true, message: "Updating Skill status" });
      try {
        const resp = await this.setUserSkill(payload);
        this.ShowProgressBar({ show: false, message: "" });
        if (!resp.success) {
          this.SetMessageDialog({ show: true, message: resp.message });
        } else {
          // this.SetMessageDialog({
          //   show: true,
          //   message: resp.message,
          //   success: resp.success,
          // });
          // await this.autoLogin();
        }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.ShowProgressBar({ show: false, message: "" });
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    async initHome() {
      this.userPermission = this.permissions;
      this.userType = this.type;
      await this.GetDomainSkills();
      await this.GetCallReasons();
      await this.GetACWSettings();
      if (this.hasPermisson(this.callerInfoPermission)) {
        await this.GetInitCRM();
        if (this.CRMInitInfo?.has_info_create) {
          await this.GetLocalCRMFields();
        }
        if (this.CRMInitInfo?.has_ticket_create) {
          await this.GetLocalTicketingFields();
        }
      }
      if (!this.hasPermisson(this.agentsReportsPermission)) {
        this.tabToggle = "2";
      }
    },
    getSelectedSkills() {
      if (this.skills) {
        this.selectedSkills = [];
        for (const skill of this.skills) {
          if (skill.selected) {
            this.selectedSkills.push(skill);
          }
        }
        return this.selectedSkills;
      } else {
        return [];
      }
    },
    setRestDuration() {
      if (!this.restEndtime) {
        return;
      }
      this.restingPeriod =
        (new Date(+this.restEndtime).getTime() - new Date().getTime()) / 1000;
      this.restStatusInt = setInterval(() => {
        if (this.restingPeriod > 0) {
          this.restingPeriod--;
        }
      }, 1000);
    },

    onResize() {
      this.statusWidth = window.innerWidth;
    },
    withACW(work) {
      return this.acwSettings?.after_work.includes(work) && this.inAcw;
    },
    ...mapActions([
      "SetMessageDialog",
      "ShowProgressBar",
      "setUserSkill",
      "GetActiveCall",
      "GetDomainSkills",
      "GetCallReasons",
      "GetACWSettings",
      "GetInitCRM",
      "GetLocalCRMFields",
      "GetLocalTicketingFields",
    ]),
    ...mapMutations(["setIncall", "setIsConnected"]),
  },
  computed: {
    ...mapGetters([
      "permissions",
      "type",
      "skills",
      "domain",
      "uname",
      "status",
      "restEndtime",
      "workPhone",
      "workPlace",
      "agentsReportsPermission",
      "queueDashboardPermission",
      "agentStatusPermission",
      "skillChoosePermission",
      "summaryStatsPermission",
      "callReasonPermission",
      "phonePermission",
      "sipPermission",
      "ticketsPermission",
      "callerInfoPermission",
      "inCall",
      "isPhoneDrawn",
      "currentCall",
      "inAcw",
      "acwSettings",
      "acwReason",
      "acwCRM",
      "acwTicketing",
      "CRMInitInfo",
      "sentiment",
      "isAnswered",
      "isIncoming",
    ]),
    setSkillStatusColor() {
      switch (this.status) {
        case 1:
          return "green-darken-3";
        case 2:
          return "amber-lighten-2";
        case 3:
          return "red-darken-1";
        default:
          return "red-darken-4";
      }
    },
    durationFormat() {
      var date = new Date(null);
      date.setSeconds(this.restingPeriod);
      return date.toISOString().substring(11, 19);
    },
    restClass() {
      if (this.status == 2) {
        return "bg-amber-lighten-2";
      } else {
        return "";
      }
    },
  },
  watch: {
    domain() {
      this.initHome();
    },
    status(value) {
      if (value == 2 && this.restEndtime) {
        this.setRestDuration();
      } else {
        clearInterval(this.restStatusInt);
      }
    },
    statusWidth(value) {
      console.log("My status width:::", value);
    },
    // sentiment(value) {
    //   console.log("My sentiment:::", value);
    //   if (value == "positive") {
    //     this.$refs.sentiment.src = require("@/assets/happy.png");
    //   } else if (value == "negative") {
    //     this.$refs.sentiment.src = require("@/assets/sad.png");
    //   } else {
    //     this.$refs.sentiment.src = require("@/assets/normal.png");
    //   }
    // },
  },
  created() {
    if (this.domain) {
      this.initHome();
    }
    if (this.status == 2 && this.restEndtime) {
      this.setRestDuration();
    } else {
      clearInterval(this.restStatusInt);
    }
  },
  unmounted() {
    if (this.currentCallTimeout) {
      clearTimeout(this.currentCallTimeout);
      this.currentCallTimeout = null;
    }
    if (this.restStatusInt) {
      clearInterval(this.restStatusInt);
      this.restStatusInt = null;
    }
  },
};
</script>
<style scoped>
.gradient-custom {
  /* fallback for old browsers */
  /* fallback for old browsers */
  background: #26a69a;

  height: 50px;
  /* Chrome 10-25, Safari 5.1-6 */
  background: -webkit-linear-gradient(to right, #26a69a, #006064);

  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background: linear-gradient(to right, #26a69a, #006064);
}
</style>
